import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { DotsLoader } from "@similarweb/ui-components";

export const StyledSeparator = styled.div`
    background-color: ${colorsPalettes.blue["400"]};
    bottom: 1px;
    height: 1px;
    left: 0;
    margin-left: 8px;
    margin-right: 8px;
    position: absolute;
    width: calc(100% - 16px);
    z-index: 2;
`;

export const StyledDropdownSearch = styled.div<{ isLoading?: boolean }>`
    position: relative;
    padding-right: ${({ isLoading }) => (isLoading ? 30 : 0)}px;

    .input-container {
        height: auto;

        input {
            padding: 22px 16px 22px 0;
        }
    }

    ${DotsLoader} {
        position: absolute;
        top: calc(50% - 3px);
        right: 5px;
    }
`;
